import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Phone, Menu, X, Star, ArrowRight } from 'lucide-react';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/73brYUsAAwR6tiFxFDLzsP/Logo.png';
const navItems = [{
  label: 'Ducted Systems',
  href: '/ducted-air-conditioning/'
}, {
  label: 'Split Systems',
  href: '/split-systems-perth/'
}, {
  label: 'Reverse Cycle',
  href: '/reverse-cycle-air-conditioning-perth/'
}, {
  label: 'Smart Zone',
  href: '/smart-zone/'
}, {
  label: 'Pricing',
  href: '#pricing'
}];
export function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [isOpenNow, setIsOpenNow] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    const checkOpen = () => {
      const now = new Date();
      const day = now.getDay();
      const hours = now.getHours();
      if (day >= 1 && day <= 4 && hours >= 9 && hours < 16) setIsOpenNow(true);else if (day === 5 && hours >= 9 && hours < 14) setIsOpenNow(true);else setIsOpenNow(false);
    };
    checkOpen();
    const interval = setInterval(checkOpen, 60000);
    return () => {
      window.removeEventListener('scroll', onScroll);
      clearInterval(interval);
    };
  }, []);
  return <div className={`sticky top-0 z-50 w-full transition-all duration-300 ${scrolled ? 'bg-white/95 backdrop-blur-md shadow-md' : 'bg-white'}`} data-id="element-230" data-mp="3fakl3s5tep3h">
      {/* Utility bar */}
      <div className={`bg-brand-soft text-brand transition-all duration-300 ${scrolled ? 'h-9' : 'h-10'} overflow-hidden`} data-id="element-231" data-mp="35jy722dqy6mw">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex items-center justify-between text-xs gap-4" data-id="element-232" data-mp="1wfsevxpur11">
          {/* Left: hours + status */}
          <div className="flex items-center gap-2 font-medium min-w-0" data-id="element-233" data-mp="3t9k86vdoivxj">
            <span className="live-dot flex-shrink-0" style={{
            background: isOpenNow ? '#16A34A' : '#A8A29E'
          }} aria-hidden="true" data-id="element-234" data-mp="1rdbdcse438ta" />
            <span className="hidden md:inline truncate" data-id="element-235" data-mp="1hmyt71a7lhno">
              {isOpenNow ? <>
                  <span className="font-bold" data-id="element-236" data-mp="1ml9zj21apa15">OPEN NOW</span>
                  <span className="mx-2 text-brand/40" data-id="element-237" data-mp="18mtx3nagu5ot">·</span>
                  <span data-id="element-238" data-mp="18pg2bg9vw93v">Mon-Thu 9-4, Fri 9-2</span>
                  <span className="mx-2 text-brand/40" data-id="element-239" data-mp="1cpq6cne48pg3">·</span>
                  <span data-id="element-240" data-mp="yp5p3vnun1op">Local Perth team</span>
                </> : <>
                  <span className="font-bold" data-id="element-241" data-mp="13nqojsva1hc3">Next callback:</span>
                  <span className="ml-2" data-id="element-242" data-mp="13q36w74y5tpo">Monday 9am</span>
                </>}
            </span>
            <span className="md:hidden font-bold truncate" data-id="element-243" data-mp="2t140a35py7n8">
              {isOpenNow ? 'OPEN NOW · Mon-Thu 9-4' : 'Callback Mon 9am'}
            </span>
          </div>

          {/* Centre: phone (moved out of cluster) */}
          <a href="tel:+61864043888" className="hidden lg:flex items-center gap-1.5 font-bold hover:text-brand-700 transition-colors" aria-label="Call Langler Air" data-id="element-244" data-mp="hg3gm0we0gca">
            <Phone size={12} strokeWidth={2.5} data-id="element-245" data-mp="rdhj0wlh74ll" />
            <span className="tabular-nums" data-id="element-246" data-mp="rbodjkmlmqf6">08 6404 3888</span>
          </a>

          {/* Right: reviews */}
          <a href="https://www.google.com/search?q=langler+air+perth+reviews" target="_blank" rel="noopener noreferrer" className="flex items-center gap-1.5 font-semibold hover:text-brand-700 transition-colors flex-shrink-0" data-id="element-247" data-mp="156z5oq9gkxfu">
            <div className="flex" data-id="element-248" data-mp="1a262de4b91v9">
              {[0, 1, 2, 3, 4].map(i => <Star key={i} size={11} className="fill-amber-400 text-amber-400" data-id="element-249" data-mp="3gv8h5fhrlhdt" />)}
            </div>
            <span className="tabular-nums hidden sm:inline" data-id="element-250" data-mp="22xvq6cbwwzoj">
              5.0 from 75 Google reviews
            </span>
            <span className="tabular-nums sm:hidden" data-id="element-251" data-mp="27vxat1ozl724">5.0 (75)</span>
          </a>
        </div>
      </div>

      {/* Main header */}
      <header className="bg-white" data-id="element-252" data-mp="2gyg7t563cpgg">
        <div className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between gap-8 transition-all duration-300 ${scrolled ? 'h-16' : 'h-20'}`} data-id="element-253" data-mp="2gxezv9kdgj2y">
          <a href="/" aria-label="Langler Air home" className="flex items-center flex-shrink-0" data-id="element-254" data-mp="1p6h7y7ptx2ij">
            <img src={LOGO_URL} alt="Langler Air" className={`w-auto transition-all duration-300 ${scrolled ? 'h-9' : 'h-11'}`} data-id="element-255" data-mp="1t7knet3yswj8" />
          </a>

          <nav className="hidden lg:flex items-center gap-x-8" aria-label="Main navigation" data-id="element-256" data-mp="11hfweblp9b91">
            {navItems.map(item => <a key={item.label} href={item.href} className="text-sm font-semibold uppercase tracking-wider text-ink-900 hover:text-brand transition-colors whitespace-nowrap" data-id="element-257" data-mp="xypg0fqtoonr">
                {item.label}
              </a>)}
          </nav>

          <div className="flex items-center gap-3" data-id="element-258" data-mp="jzhbd7bw4oc6">
            <a href="tel:+61864043888" className="lg:hidden flex items-center gap-1.5 text-brand font-bold text-sm" aria-label="Call Langler Air" data-id="element-259" data-mp="f0mn3pv5m7ko">
              <Phone size={14} strokeWidth={2.5} data-id="element-260" data-mp="5al6tk91ltgb" />
              <span className="tabular-nums hidden sm:inline" data-id="element-261" data-mp="5bcqbwpd80q8">
                08 6404 3888
              </span>
            </a>
            <a href="#quote-form" className="hidden sm:inline-flex items-center gap-1.5 h-12 px-5 rounded-xl bg-accent hover:bg-accent-600 text-ink-900 text-sm font-bold transition-all duration-200 hover:scale-[1.02] active:scale-[0.98] shadow-md hover:shadow-lg whitespace-nowrap" data-id="element-262" data-mp="3sfsxvaiorsec">
              Get Free Quote
              <ArrowRight size={15} strokeWidth={2.5} data-id="element-263" data-mp="3isyj0uhm98kk" />
            </a>
            <button onClick={() => setIsOpen(!isOpen)} className="lg:hidden p-2 -mr-2 text-ink-900" aria-label={isOpen ? 'Close menu' : 'Open menu'} aria-expanded={isOpen} data-id="element-264" data-mp="33vpl1hxt56jv">
              {isOpen ? <X size={26} data-id="element-265" data-mp="gackl52v50u" /> : <Menu size={26} data-id="element-266" data-mp="5dajszdnydtj" />}
            </button>
          </div>
        </div>

        <AnimatePresence data-id="element-267" data-mp="5fd6b9flxoti">
          {isOpen && <motion.div initial={{
          opacity: 0,
          y: -10
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -10
        }} transition={{
          duration: 0.2
        }} className="lg:hidden bg-white border-t border-stone-200 overflow-hidden" data-id="element-268" data-mp="3mujxgk9stuwv">
              <nav className="flex flex-col px-4 py-3" aria-label="Mobile navigation" data-id="element-269" data-mp="23vdswl2v2g25">
                {navItems.map(item => <a key={item.label} href={item.href} onClick={() => setIsOpen(false)} className="py-3 text-base font-semibold text-ink-900 border-b border-stone-200 last:border-0 hover:text-brand" data-id="element-270" data-mp="2iltfa370ju1w">
                    {item.label}
                  </a>)}
                <div className="grid grid-cols-2 gap-2 mt-4 mb-2" data-id="element-271" data-mp="1yxc7vulvk6o1">
                  <a href="tel:+61864043888" className="flex items-center justify-center gap-2 h-12 rounded-xl border-2 border-brand text-brand text-sm font-bold" data-id="element-272" data-mp="1utctpio2hjxu">
                    <Phone size={14} data-id="element-273" data-mp="3691fw7thyexl" /> Call us
                  </a>
                  <a href="#quote-form" onClick={() => setIsOpen(false)} className="flex items-center justify-center h-12 rounded-xl bg-accent text-ink-900 text-sm font-bold" data-id="element-274" data-mp="13np4i5b83z1r">
                    Free Quote
                  </a>
                </div>
              </nav>
            </motion.div>}
        </AnimatePresence>
      </header>
    </div>;
}